import { ChameleonRequest } from "@repo/chameleon-request";
import { getApiUrl } from "@repo/utils/get-api-url";
import { BagResponseV4 } from "./bag.type";
import { buildExpandQueryValue, ExpandOptions } from "./utils/expand";

export type AddProductOptions = {
  chameleonRequestInstance: ChameleonRequest;
  asosBagSessionToken: string;
  bagId: string;
  variantId: number;
  authHeader: string;
  store: string;
  lang: string;
  expand?: ExpandOptions;

  // TODO: Handle adding limited drops
  // ref: https://github.com/asosteam/asos-core-api-specifications/blob/2747aee4a0d69ca60cb9a77ba74ea726f00a8543/commerce-bag/api/commerce-bag-v4.yaml#L4594-L4606
  // productAuthorizationHeader?: string;
};

export async function addProduct({
  chameleonRequestInstance,
  asosBagSessionToken,
  bagId,
  variantId,
  authHeader,
  store,
  lang,
  expand,

  // TODO: Handle adding limited drops
  // productAuthorizationHeader,
}: AddProductOptions) {
  const expandQueryValue = buildExpandQueryValue(expand);

  const url = getApiUrl({
    path: `/commerce/bag/v4/bags/${bagId}/product`,
    searchParams: {
      lang,
      ...(expandQueryValue ? { expand: expandQueryValue } : {}),
    },
  });

  const { data, responseHeaders } =
    await chameleonRequestInstance.post<BagResponseV4>(url, {
      headers: {
        "Content-Type": "application/json",
        "asos-c-store": store,
        "asos-bag-session-token": asosBagSessionToken,
        Authorization: authHeader,
      },
      body: JSON.stringify({
        variantId,
      }),
    });

  return {
    data,
    bagSessionToken: responseHeaders["asos-bag-session-token"] as string,
  };
}
